/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

export const FETCH_ETEXT_PUBLISH_SUCCESS = 'FETCH_ETEXT_PUBLISH_SUCCESS';
export const FETCH_ETEXT_OPTIMIZE_SUCCESS = 'FETCH_ETEXT_OPTIMIZE_SUCCESS';
export const FETCH_PRODUCT_DETAILS_SUCCESS ='FETCH_PRODUCT_DETAILS_SUCCESS';
export const FETCH_OFFER_DETAILS_SUCCESS ='FETCH_OFFER_DETAILS_SUCCESS';
export const UPDATE_COPYABLE_STATUS='UPDATE_COPYABLE_STATUS';
export const UPDATE_PRODUCT_STAGE='UPDATE_PRODUCT_STAGE';
export const UPDATE_OFFER_END_DATE='UPDATE_OFFER_END_DATE';

export function fetchEtextStatusSuccess(payload) {
    return {type: FETCH_ETEXT_PUBLISH_SUCCESS, payload: payload};
}

export function fetchEtextOptimizeStatusSuccess(payload) {
    return {type: FETCH_ETEXT_OPTIMIZE_SUCCESS, payload: payload};
}

export function fetchProductDetailsSuccess (payload) {
    return {type: FETCH_PRODUCT_DETAILS_SUCCESS, payload: payload};
}

export function fetchOfferDetailsSuccess (payload) {
    return {type: FETCH_OFFER_DETAILS_SUCCESS, payload: payload};
}

export function updateCopyableStatus(payload) {
    return {type: UPDATE_COPYABLE_STATUS, payload: payload};
}

export function updateProductStage(payload) {
    return {type: UPDATE_PRODUCT_STAGE, payload: payload};
}

export function updateOffer(payload) {
    return {type: UPDATE_OFFER_END_DATE, payload: payload};
}


// WEBPACK FOOTER //
// ./src/_actions/etext.publish.actions.js